//

(function () {
  // Ensure the script runs only after the DOM is fully loaded
  document.addEventListener("DOMContentLoaded", function () {
    // Fallback for browsers without IntersectionObserver (ex: old Edge).
    if (!("IntersectionObserver" in window)) {
      var blocksToAnimate = document.querySelectorAll(".tw-block-animation");
      for (var i = 0; i < blocksToAnimate.length; i++) {
        blocksToAnimate[i].classList.add("animated");
      }
    }

    // Find the navigation elements
    var navContainer = document.querySelector(".wp-block-navigation");
    if (!navContainer) return; // Exit if no navigation found

    var openButton = navContainer.querySelector(
      ".wp-block-navigation__responsive-container-open"
    );
    var closeButton = navContainer.querySelector(
      ".wp-block-navigation__responsive-container-close"
    );
    var modal = navContainer.querySelector(
      ".wp-block-navigation__responsive-container"
    );

    // Check if all necessary elements exist
    if (!openButton || !closeButton || !modal) {
      console.error(
        "Fallback Nav Error: Could not find all required menu elements."
      );
      return;
    }

    // Function to open the menu
    function openMenu() {
      modal.classList.add("has-modal-open");
      modal.classList.add("is-menu-open");
      // Optional: Add focus management if needed for accessibility
      // closeButton.focus();
    }

    // Function to close the menu
    function closeMenu() {
      modal.classList.remove("has-modal-open");
      modal.classList.remove("is-menu-open");
      // Optional: Return focus to the open button
      // openButton.focus();
    }

    // Add event listener for the open button
    openButton.addEventListener("click", function (event) {
      event.preventDefault(); // Prevent default button behavior
      openMenu();
    });

    // Add event listener for the close button
    closeButton.addEventListener("click", function (event) {
      event.preventDefault(); // Prevent default button behavior
      closeMenu();
    });

    // Optional: Add event listener to close menu when clicking outside
    modal.addEventListener("click", function (event) {
      // Close only if clicking directly on the modal background (not its children)
      if (event.target === modal) {
        closeMenu();
      }
    });

    // Optional: Add event listener to close menu with the Escape key
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" || event.keyCode === 27) {
        if (modal.classList.contains("is-menu-open")) {
          closeMenu();
        }
      }
    });
  });
})();
